<div *ngIf="show" class="product-popup-container" fxLayout="row" fxLayoutAlign="center center">
    <div class="party-set-container">
        <div class="title">{{productSku.productSkuEavs | getValueByAttribute:'name':'value'}}</div>
        <div fxLayout="row wrap" fxLayoutAlign="center start" class="content">
            <img [src]="productSku.images | getImagePathByType:'THUMBNAIL'" alt="">
            <div class="component">
                <div *ngFor="let name of components">{{name}}</div>
            </div>
        </div>
        <button class="cross" (click)="close()" i18n-aria-label="@@popup.close.aria" aria-label="Close">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
                <path d="M18 6 6 18M6 6l12 12"/>
            </svg>
        </button>
    </div>
</div>
